export enum ShipmentActionType {
    Unknown = -1,
    Origin = 0,
    Delivery = 1,
    Backhaul = 2,
    Destination = 3
}

export const ShipmentActionTypeMetadata = {
    '0': {
        display: 'Origin',
        value: 0
    },
    '1': {
        display: 'Delivery',
        value: 1
    },
    '2': {
        display: 'Backhaul',
        value: 2
    },
    '3': {
        display: 'Destination',
        value: 3
    }
};
